import { Window, Cordova, CapacitorInfo } from '@/types/window'
import { Platform } from '@/constants/app'

export const setCordova = (cordova: { platformId: Platform }) => {
  const w = window as Window
  w.cordova = cordova as Cordova
}

export const setCapacitor = (capacitor: CapacitorInfo) => {
  const w = window as Window
  w.capacitor = capacitor
}
